import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '../../../../store/store';
import NewsletterTemplateSelection from '../../../Communication/NewsletterTemplateSelection';

export interface TemplateStepHandle {
  isValid: () => boolean;
  getPartialDraft: () => { defaultTemplate?: string };
  focusFirstInvalid: () => void;
}

const TemplateStep = forwardRef<TemplateStepHandle>((_, ref) => {
  const company = useSelector((s: RootState) => s.auth.company);
  const [selected, setSelected] = useState<string | undefined>(company?.brandingSettings?.defaultTemplate);

  useImperativeHandle(ref, () => ({
    isValid: () => Boolean(selected || company?.brandingSettings?.defaultTemplate),
    getPartialDraft: () => ({ defaultTemplate: selected }),
    focusFirstInvalid: () => {},
  }), [selected, company?.brandingSettings?.defaultTemplate]);

  return (
    <div>
      <h3 className="mb-4 text-lg font-semibold text-gray-800">Template de newsletter par défaut</h3>
      <p className="mb-4 text-sm text-gray-600">Choisissez le modèle par défaut pour vos newsletters. Vous pourrez le changer plus tard.</p>
      {/* Reuse existing component. It currently patches on selection. We'll keep that behavior but also capture the selection locally. */}
      <NewsletterTemplateSelection
        hideBackButton
        onSelected={(name: string) => setSelected(name)}
      />
    </div>
  );
});

TemplateStep.displayName = 'TemplateStep';

export default TemplateStep;


